import axios, { AxiosStatic, AxiosPromise } from "axios";

import { PhysiotherapyReferralCaseCreateModel } from "../physiotherapy/models";

import { AnsweredQuestionWithId } from "./model";

export class QuestionnaireApi {

    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public submit(questions: AnsweredQuestionWithId[], apiUrl: string): AxiosPromise {
        return this.axios.post(apiUrl, { questions });
    }

    public submitPhysiotherapyReferralQuestionnaire(physiotherapyReferralCase: PhysiotherapyReferralCaseCreateModel, apiUrl: string): AxiosPromise {
        return this.axios.post(apiUrl, physiotherapyReferralCase);
    }

    public load(customerId: string, id: string, caseId: string, apiUrl: string): AxiosPromise {
        if (customerId && caseId) {
            // Use only provided apiUrl
            return this.axios.get(apiUrl);
        }
        else if (caseId) {
            // View completed form
            return this.axios.get(`${apiUrl}/${caseId}`);
        } else {
            // Create form
            return this.axios.get(`${apiUrl}/${customerId}/${id}`);
        }
    }
}

export default new QuestionnaireApi(axios);
